module.exports = __webpack_public_path__ + "static/media/Carousel-1.59dc3041.webp";